import Rewards from './Rewards.container';

export default Rewards;
